import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCardButton = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 9,
			height: 9,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			width: 9,
			height: 9,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 11,
			width: 9,
			height: 9,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 11,
			width: 9,
			height: 9,
			rx: 1
		})
	]
});
export default SvgCardButton;
